import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiMapPin, FiHome, FiSearch, FiShield , FiSquare} from 'react-icons/fi';
import "../../css/Projects.css";
import { Navbar } from "./Navbar";

export const ResidentialApartment = () => {
    
    const [project, setProject] = useState(null);
    const [media, setMedia] = useState([]);
    const [similarProjects, setSimilarProjects] = useState([]);
    const [almostready, setAlmostReady] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`/api/resale-apartment`)
            .then(res => {
                console.log("res.data", res.data);
                setSimilarProjects(res.data);
            })
            .catch(err => {
                console.error("Error fetching similar projects:", err);
            });
    }, [project]);

  return (
    <div> 
        <Navbar />
        <div className="margin"></div>
           <div className="topic1">

             <h3 className="topic-title">
                                    <span className="diamond"></span>Premium Resale Apartment for Sale in Chennai <span className="diamond"></span></h3>
            
                                <div className="projects-grid">
                                    {Array.isArray(similarProjects) && similarProjects.map((project) => (
                                        <a
                                            key={project.projectid}
                                            href={`/property/Residential/${project.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="property-card1"
                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                        >
                                            <div className="card-image">
                                                <img src={project.image} alt={project.bpn} />
                                                <span className="badge verified "><FiShield /> Verified</span>
                                                {/* <span className="badge status">Under Construction</span> */}
                                            </div>
                                            <div className="card-content">
                                                <div className="flex">
                                                 <h3>{project.bpn}</h3> - 
                                                    <p className="devr">{project.proptypename}</p>
                                                </div>
            
                                                <p className="icon-text">
                                                    <FiMapPin /> {project.city}, {project.pinlocality}
                                                </p>
                                                <div className='flex'>
                                                                    <p className="icon-text">
                                                                   {project.bhk && (
                                                  <span><FiHome /> {project.bhk ? project.bhk.replace(/bhk/gi, '').split(',').join('&') + ' BHK' : 'N/A'} |</span>
                                                )}
                                                                     {project. buitupareasq &&(<span><FiSquare/> {project. buitupareasq} |</span>) }
                                                                    </p>
                                                                    <p className="icon-text">
                                                                      {project.cost && (<span>₹{project.cost}</span>)}
                                                                    </p>
                                                                  </div>
                                                <div className="card-actions"  >
                                                    <button className="btn view">
                                                        <FiSearch /> View Details
                                                    </button>
            
                                                </div>
                                            </div>
                                        </a>
                                    ))
                                    }
                                </div>
            </div>
           </div>
  )
}
